import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/layout";
import dashboardclasses from "../dashboard.module.css";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";
const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
function Reports() {
    const Navigate = useNavigate();
    const [warehouse, setWarehouse] = useState([]);
    const [loading, setLoading] = useState(true);
    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const formData = watch();
    useEffect(() => {
        const getwarehouses = () => {
            Services.getwarehouses("GET", null, token)
                .then((res) => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 300);
                    console.log("1", res);
                    if (res.Status === 1) {
                        setWarehouse(res.warehouses);
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        if (res.Message === "Token expired") {
                            Navigate("/");
                        }
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        };
        getwarehouses();
    }, []);
    const onSubmit = (data) => {
        setLoading(true);
        if (data.type == "GST") {
            if (data?.Service == "Service") {
                Services.GetGst("GET", null, token, data.City)
                    .then((res) => {
                        console.log("1", res);
                        if (res.Status === 1) {
                            fetch(res.CsvFile).then((response) => {
                                response.blob().then((blob) => {
                                    // Creating new object of PDF file
                                    const fileURL =
                                        window.URL.createObjectURL(blob);
                                    // Setting various property values
                                    let alink = document.createElement("a");
                                    alink.href = fileURL;
                                    alink.download = `${data.City}.xlsx`;
                                    alink.click();
                                    setLoading(false);
                                    reset();
                                });
                            });
                        } else if (res.Status === 0) {
                            setLoading(false);
                            toast.error(`${res.Message}`, {
                                position: "top-center",
                                autoClose: 1000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            if (res.Message === "Token expired") {
                                Navigate("/");
                            }
                        }
                    })
                    .catch((err) => {
                        // alert(err);
                        setLoading(false);
                        alert("something went wrong please try again");
                        console.log(err);
                    });
            } else {
                Services.GetGstProduct("GET", null, token, data.City)
                    .then((res) => {
                        console.log("1", res);
                        if (res.Status === 1) {
                            fetch(res.CsvFile).then((response) => {
                                response.blob().then((blob) => {
                                    // Creating new object of PDF file
                                    const fileURL =
                                        window.URL.createObjectURL(blob);
                                    // Setting various property values
                                    let alink = document.createElement("a");
                                    alink.href = fileURL;
                                    alink.download = `${data.City}.xlsx`;
                                    alink.click();
                                    setLoading(false);
                                    reset();
                                });
                            });
                        } else if (res.Status === 0) {
                            setLoading(false);
                            toast.error(`${res.Message}`, {
                                position: "top-center",
                                autoClose: 1000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            if (res.Message === "Token expired") {
                                Navigate("/");
                            }
                        }
                    })
                    .catch((err) => {
                        // alert(err);
                        setLoading(false);
                        alert("something went wrong please try again");
                        console.log(err);
                    });
            }
        } else {
            Services.allReportsDownload("POST", JSON.stringify(data), token)
                .then((res) => {
                    console.log("1", res);
                    if (res.Status === 1) {
                        fetch(res.CsvFile).then((response) => {
                            response.blob().then((blob) => {
                                // Creating new object of PDF file
                                const fileURL =
                                    window.URL.createObjectURL(blob);
                                // Setting various property values
                                let alink = document.createElement("a");
                                alink.href = fileURL;
                                alink.download = `${data.type}.xlsx`;
                                alink.click();
                                setLoading(false);
                                reset();
                            });
                        });
                    } else if (res.Status === 0) {
                        setLoading(false);
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        if (res.Message === "Token expired") {
                            Navigate("/");
                        }
                    }
                })
                .catch((err) => {
                    // alert(err);
                    setLoading(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    return (
        <Layout Active={"Reports"}>
            {loading && (
                <div className={dashboardclasses["report-modal"]}>
                    <div className={dashboardclasses["report-spinner"]}>
                        <FadeLoader color="#36d7b7" radius={"6px"} />
                    </div>
                </div>
            )}
            <div className={dashboardclasses["dashboard-rightside"]}>
                <div className={dashboardclasses.CategoryWrapper}>
                    <h3>Reports</h3>
                    <div className={dashboardclasses["reports"]}>
                        <form
                            className={dashboardclasses["add-items"]}
                            onSubmit={handleSubmit(onSubmit)}>
                            <h3>Reports</h3>
                            <div
                                className={
                                    dashboardclasses["item-image-upload"]
                                }>
                                {/* <label htmlFor="categoryname">Warehouse</label> */}
                                <div className={dashboardclasses["select"]}>
                                    <select
                                        {...register("type", {
                                            required:
                                                "Report type  is required",
                                        })}
                                        defaultValue={""}>
                                        <option value="" disabled>
                                            Select Report Type
                                        </option>
                                        <option value="productReports">
                                            product Reports
                                        </option>
                                        <option value="StockReports">
                                            Stock Reports
                                        </option>
                                        <option value="GST">GST</option>
                                        <option value="Orders">Orders</option>
                                    </select>
                                    {errors?.type && (
                                        <p
                                            className={
                                                dashboardclasses["error"]
                                            }>
                                            {errors?.type?.message}
                                        </p>
                                    )}
                                </div>
                            </div>
                            {formData.type == "GST" && (
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    {/* <label htmlFor="categoryname">Warehouse</label> */}
                                    <div className={dashboardclasses["select"]}>
                                        <select
                                            {...register("City", {
                                                required: "City  is required",
                                            })}
                                            defaultValue={""}>
                                            <option value="" disabled>
                                                Selected City
                                            </option>
                                            <option value="hyderabad">
                                                Hyderabad
                                            </option>
                                            <option value="vijayawada">
                                                Vijayawada
                                            </option>
                                        </select>
                                        {errors?.City && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.City?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {formData.type == "GST" && (
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    {/* <label htmlFor="categoryname">Warehouse</label> */}
                                    <div className={dashboardclasses["select"]}>
                                        <select
                                            {...register("Service", {
                                                required:
                                                    "Service  is required",
                                            })}
                                            defaultValue={""}>
                                            <option value="" disabled>
                                                Selected Type
                                            </option>
                                            <option value="Product">
                                                Product
                                            </option>
                                            <option value="Service">
                                                Service
                                            </option>
                                        </select>
                                        {errors?.City && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.City?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {formData.type == "Orders" && (
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    {/* <label htmlFor="categoryname">Warehouse</label> */}
                                    <div className={dashboardclasses["select"]}>
                                        <select
                                            {...register("orderType", {
                                                required:
                                                    "order Type  is required",
                                            })}
                                            defaultValue={""}>
                                            <option value="" disabled>
                                                Select Order Type
                                            </option>
                                            <option value="1">
                                                Service Orders
                                            </option>
                                            <option value="2">
                                                Grocery Orders
                                            </option>
                                        </select>
                                        {errors?.orderType && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.orderType?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {formData.type != "Orders" &&
                                formData.type != "GST" && (
                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        {/* <label htmlFor="categoryname">Warehouse</label> */}
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <select
                                                {...register("warehouseId", {
                                                    required:
                                                        "warehouse  is required",
                                                })}
                                                defaultValue={""}>
                                                <option value="" disabled>
                                                    Select warehouse
                                                </option>
                                                {warehouse.map((item) => (
                                                    <option
                                                        value={
                                                            item.warehouseId
                                                        }>
                                                        {item.warehousename}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors?.warehouseId && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors?.warehouseId
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}

                            <div className={dashboardclasses["add-btn"]}>
                                <button
                                    type="submit"
                                    className={
                                        dashboardclasses["add-category-btn"]
                                    }>
                                    Download
                                </button>
                            </div>
                        </form>{" "}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Reports;
